export const SERVICE_TYPE_STEP = "SERVICE_TYPE_STEP";
export const PACKAGE_TYPE_STEP = "PACKAGE_TYPE_STEP";
export const CONTRACT_STEP = "CONTRACT_STEP";
export const BILLING_INFO_STEP = "BILLING_INFO_STEP";
export const PAYMENT_METHOD_STEP = "PAYMENT_METHOD_STEP";
